import React, { useState, useEffect, useRef } from "react";
import InputBox from "../../components/InputBox";
import {
  getPredictLimits,
  getPredictionData,
  getPredictionStatus,
  predictionCalculation,
} from "../../network/cipAPI";
import DupontButton from "../../components/DupontButton";
import PageLoading from "../../components/PageLoading";
import { OverlayLoader } from "../../components/PageLoading";
import BoxCompontent from "../../components/BoxComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  storeForcastWindow,
  storePredictionData,
} from "../../Store/TemplateStore/template.action";
import CriticalDeleteDialog from "../../components/CriticalDeleteDialog";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";
import AgTable from "../../components/AgTable";
import {
  dateFormatter,
  formattedCurrencyValue,
} from "../../utils/tableDataFormatter";
import createNotification, {
  ERROR_NOTIFICATION,
} from "../../components/Notifications";

import moment from "moment";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";
import QuestionIcon from "../../assets/question-icon.svg";
import {
  getSortedData,
  predictTypeFormatter,
  cleaningFormatter,
} from "../../utils/tableDataFormatter";
import exportAllTables from "../../XLSDownload/ExportAllTables/index.js";
import ExportAllData from "./exportAllData";
import { useTranslation } from "react-i18next";
import { storeCATaskId } from "../../Store/TemplateStore/template.action";
import XTPBenefits from "./XTPBenefits.js";
import { integraTecXTPStrings } from "../../constants/integraTecXTPStrings";
import { APPINSIGHTS_STRINGS } from "../../constants/appInsightsStrings";
import { trackEvent } from "../../utils/appInsights";

const PredictCIP = ({ setDisableNextButton }) => {
  const { t } = useTranslation();
  const intervalRef = useRef(null);
  const [forecastDays, setForecastDays] = useState(
    useSelector((state) => state.forecastWindow)
  );
  const [limitWindow, setLimitWindow] = useState(null);
  const [foulingType, setfoulingType] = useState(
    useSelector((state) => state.foulingType)
  );
  const [predictionData, setPredictionData] = useState(
    useSelector((state) => state.predictionData)
  );
  const [isOutSideRange, setIsOutsideRange] = useState(false);
  const [isOutsideSoftLimit, setIsOutsideSoftLimit] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [errorMsgFailedPrediction, setErrorMsgFailedPrediction] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [processedPercentage, setprocessedPercentage] = useState(false);
  const [showOverlayLoader, setShowOverlayLoader] = useState(false);
  const plantLocation = useSelector((state) => state.plantLocation);
  const plantName = useSelector((state) => state.plantName);
  const [taskId, setTaskId] = useState(useSelector((state) => state.CATaskId));
  const volumeUnit = useSelector((state) => state.volume);
  const pressure = useSelector((state) => state.pressure);
  const optimization_target = useSelector((state) => state.optimization_target);
  const setTotalbenefitWindow = () => {
    return `${moment(limitWindow?.["max_date"]).format(
      "DD/MM/YYYY"
    )} - ${moment(limitWindow?.["max_date"])
      .add("days", forecastDays)
      .format("DD/MM/YYYY")}`;
  };
  const setAnnualbenefitWindow = () => {
    return ` ${moment(limitWindow?.["max_date"]).format(
      "DD/MM/YYYY"
    )} - ${moment(limitWindow?.["max_date"])
      .add("year", 1)
      .format("DD/MM/YYYY")}`;
  };
  const allData = ExportAllData();
  const [exportAllData, setExportAllData] = useState({
    ...allData,
    predictionDataRaw: predictionData,
    predictionandRecommendData: rowData,
    optimization_target: optimization_target,
  });
  const [exportAllSheetName, setExportAllSheetName] = useState(
    `${plantLocation.trim()}_${plantName.trim()}_${moment().format(
      "MM/DD/YYYY"
    )}_${t("predictionStrings.cleaningAdvisorReport")}`
  );
  const dispatch = useDispatch();

  const extractPredictionData = (key, defaultValue = 0) =>
    predictionData ? predictionData[key] || defaultValue : defaultValue;

  const annualTotalFinancialBenefits = extractPredictionData(
    "annual_total_financial_benefits"
  );
  const totalFinancialBenefits = extractPredictionData(
    "total_financial_benefits"
  );
  const increasedProduction = extractPredictionData("increased_production");
  const increasedProductionPercent = extractPredictionData(
    "increased_production_percent"
  );

  const energySaving = extractPredictionData("energy_saving_dollars");
  const energySavingPercent = extractPredictionData("energy_saving_percent");

  const increasedProductionAnnual = extractPredictionData(
    "annual_increased_production"
  );
  const increasedProductionPercentAnnual = extractPredictionData(
    "annual_increased_production_percent"
  );

  const energySavingAnnual = extractPredictionData(
    "annual_energy_saving_dollars"
  );
  const energySavingPercentAnnual = extractPredictionData(
    "annual_energy_saving_percent"
  );

  const xtpSavings = extractPredictionData("xtp_savings");

  const getIndex = (params, column) => {
    return column ? params.node.rowIndex + 1 : "-";
  };

  const formatDate = (params, date) => {
    return date ? dateFormatter(params) : "-";
  };

  const colDef = [
    {
      headerName: t("predictionStrings.predictedSchedule"),
      headerClass: "my-css-class",
      children: [
        {
          headerName: t("predictionStrings.index"),
          valueGetter: (params) =>
            getIndex(params, params.data.predictedItem.start_date),
          flex: 1,
          headerClass: "custom-Header-cip-user-table",
          minWidth: 80,
        },
        {
          headerName: t("predictionStrings.type"),
          field: "predictedItem.type",
          valueFormatter: (params) => predictTypeFormatter(params, t),
          editable: false,
          sortable: true,
          flex: 1,
          headerClass: "custom-Header-cip-user-table",
          minWidth: 100,
        },
        {
          headerName: t("predictionStrings.startDate"),
          field: "predictedItem.start_date",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) =>
            formatDate(params, params.data.predictedItem.start_date),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 120,
        },
        {
          headerName: t("predictionStrings.nextStartDate"),
          field: "predictedItem.next_start_date",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) =>
            formatDate(params, params.data.predictedItem.start_date),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 120,
        },
        {
          headerName: t("predictionStrings.averageDurationBetweenBackwash"),
          field: "predictedItem.predicted_average_duration_between_backwash",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) => cleaningFormatter(params),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 200,
        },
        {
          headerName: t("predictionStrings.averageBackwashDurationSecs"),
          field: "predictedItem.predicted_average_backwash_duration_secs",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) => cleaningFormatter(params),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 200,
        },
        {
          headerName: t("predictionStrings.averageDurationBetweenCeb"),
          field: "predictedItem.predicted_average_duration_between_ceb",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) => cleaningFormatter(params),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 200,
        },
        {
          headerName: t("predictionStrings.averageCebDurationSecs"),
          field: "predictedItem.predicted_average_ceb_duration_secs",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) => cleaningFormatter(params),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 200,
        },
      ],
    },
    {
      headerName: t("predictionStrings.recommendedSchedule"),
      headerClass: "my-css-class",
      children: [
        {
          headerName: t("predictionStrings.index"),
          valueGetter: (params) =>
            getIndex(params, params.data.recommendedItem.start_date),
          flex: 1,
          headerClass: "custom-Header-cip-user-table",
          minWidth: 80,
        },
        {
          headerName: t("predictionStrings.type"),
          field: "recommendedItem.type",
          valueFormatter: (params) => predictTypeFormatter(params, t),
          editable: false,
          sortable: true,
          flex: 1,
          headerClass: "custom-Header-cip-user-table",
          minWidth: 100,
        },
        {
          headerName: t("predictionStrings.startDate"),
          field: "recommendedItem.start_date",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) =>
            formatDate(params, params.data.recommendedItem.start_date),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 120,
        },
        {
          headerName: t("predictionStrings.nextStartDate"),
          field: "recommendedItem.next_start_date",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) =>
            formatDate(params, params.data.recommendedItem.start_date),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 120,
        },
        {
          headerName: t("predictionStrings.averageDurationBetweenBackwash"),
          field: "recommendedItem.recommend_average_duration_between_backwash",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) => cleaningFormatter(params),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 200,
        },
        {
          headerName: t("predictionStrings.averageBackwashDurationSecs"),
          field: "recommendedItem.recommend_average_backwash_duration_secs",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) => cleaningFormatter(params),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 200,
        },
        {
          headerName: t("predictionStrings.averageDurationBetweenCeb"),
          field: "recommendedItem.recommend_average_duration_between_ceb",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) => cleaningFormatter(params),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 200,
        },
        {
          headerName: t("predictionStrings.averageCebDurationSecs"),
          field: "recommendedItem.recommend_average_ceb_duration_secs",
          editable: false,
          sortable: true,
          flex: 1,
          valueFormatter: (params) => cleaningFormatter(params),
          headerClass: "custom-Header-cip-user-table",
          minWidth: 200,
        },
      ],
    },
  ];

  const financialBenefits = {
    energy_saving: t("predictionStrings.energySaving"),
    chemical_saving: t("predictionStrings.chemicalSaving"),
    downtime_saving: t("predictionStrings.downtimeSaving"),
    increased_production: t("predictionStrings.waterProduction"),
  };

  const annualBenefits = {
    annual_energy_saving: t("predictionStrings.energySaving"),
    annual_chemical_saving: t("predictionStrings.chemicalSaving"),
    annual_downtime_saving: t("predictionStrings.downtimeSaving"),
    annual_increased_production: t("predictionStrings.waterProduction"),
  };

  const onForecastDaysChange = (value) => {
    if (value) setForecastDays(parseInt(value));
    else {
      setForecastDays(null);
    }
  };
  const onBackClicked = () => {
    setIsOutsideRange(false);
    setIsLoading(false);
  };

  const checkStatus = async (task_id) => {
    try {
      console.log("task_id", task_id);

      let id = task_id || taskId;
      let predictionStatus;
      if (id === "" || id === null || id === undefined) {
        predictionStatus = { data: { status: "pending" } };
      } else {
        predictionStatus = await getPredictionStatus(id);
      }

      try {
        const status = predictionStatus?.data?.status?.toLowerCase();
        if (status === "completed") {
          clearInterval(intervalRef.current);
          setShowOverlayLoader(false);
          dispatch(storeCATaskId(""));
          setTaskId("");

          const predicitionData = await getPredictionData(forecastDays);
          setIsLoading(false);
          setDisableNextButton(false);
          if (predicitionData?.data["modeling"]) {
            const d = predicitionData?.data["modeling"].replaceAll(
              "-Infinity",
              '"-Infinity"'
            );

            const parsedData = JSON.parse(d);

            setPredictionData(parsedData);
            setIsLoading(false);
            setDisableNextButton(false);
            dispatch(storePredictionData(parsedData));
            setErrorMsgFailedPrediction("");
          }
        } else if (status === "pending") {
          setIsLoading(false);
          setShowOverlayLoader(false);
          clearInterval(intervalRef.current);
          setDisableNextButton(false);
          setprocessedPercentage("");
        } else if (status === "running") {
          setprocessedPercentage(predictionStatus?.data.processed);
          setIsLoading(true);
          setShowOverlayLoader(false);
          setDisableNextButton(true);
          setErrorMsgFailedPrediction("");
        } else if (status === "failed") {
          setprocessedPercentage("");
          setShowOverlayLoader(false);
          setErrorMsgFailedPrediction(t("predictionStrings.failedPrediction"));
          setIsLoading(false);
          setDisableNextButton(false);
          clearInterval(intervalRef.current);
          createNotification(
            ERROR_NOTIFICATION,
            t("predictionStrings.failedPrediction"),
            ""
          );
          dispatch(storeCATaskId(""));
          setTaskId("");
        }
        return status;
      } catch (err) {
        return "failed";
      }
    } catch (err) {
      if (err.code === "ERR_NETWORK" || err.response.status === 502) {
        console.log("Error is " + err);
      } else {
        clearInterval(intervalRef.current);
        setIsLoading(false);
        setShowOverlayLoader(false);
        setDisableNextButton(false);
        setprocessedPercentage("");
        dispatch(storeCATaskId(""));
        if (rowData === null)
          setErrorMsgFailedPrediction(t("predictionStrings.errorPrediction"));
        console.log("Error is " + err);
        setTaskId("");
        return "failed";
      }
    }
  };

  useEffect(() => {
    setShowOverlayLoader(true);
    setDisableNextButton(true);
    checkStatus();
    // id = setInterval(function () {
    //   checkStatus();
    // }, 15000);
    // return () => {
    //   clearInterval(id);
    // };

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const totalBenefitWindow = setTotalbenefitWindow();
    const annualBenefitsWindow = setAnnualbenefitWindow();

    setExportAllData({
      ...exportAllData,
      predictionandRecommendData: rowData,
      totalbenefitWindow: totalBenefitWindow,
      annualBenefitsWindow: annualBenefitsWindow,
      predictionDataRaw: predictionData,
      optimization_target: optimization_target,
    });
  }, [predictionData, rowData, optimization_target]);

  useEffect(() => {
    if (forecastDays && predictionData) {
      const rowData = [];
      const maxLength = Math.max(
        predictionData["recommended_cleaning_date"].length,
        predictionData["predicted_cleaning_date"].length
      );

      for (let i = 0; i < maxLength; i++) {
        const recommendedItem = {
          type: predictionData["recommend_cleaning_type"][i] || null,
          start_date: predictionData["recommended_cleaning_date"][i] || null,
          next_start_date:
            i < maxLength - 1
              ? predictionData["recommended_cleaning_date"][i + 1]
              : null,
          recommend_average_duration_between_backwash:
            predictionData["recommend_average_duration_between_backwash"][i] ||
            null,
          recommend_average_backwash_duration_secs:
            predictionData["recommend_average_backwash_duration_secs"][i] ||
            null,
          recommend_average_duration_between_ceb:
            predictionData["recommend_average_duration_between_ceb"][i] || null,
          recommend_average_ceb_duration_secs:
            predictionData["recommend_average_ceb_duration_secs"][i] || null,
        };

        const predictedItem = {
          type: predictionData["predicted_cleaning_type"][i] || null,
          start_date: predictionData["predicted_cleaning_date"][i] || null,
          next_start_date:
            i < maxLength - 1
              ? predictionData["predicted_cleaning_date"][i + 1]
              : null,
          predicted_average_duration_between_backwash:
            predictionData["predicted_average_duration_between_backwash"][i] ||
            null,
          predicted_average_backwash_duration_secs:
            predictionData["predicted_average_backwash_duration_secs"][i] ||
            null,
          predicted_average_duration_between_ceb:
            predictionData["predicted_average_duration_between_ceb"][i] || null,
          predicted_average_ceb_duration_secs:
            predictionData["predicted_average_ceb_duration_secs"][i] || null,
        };
        rowData.push({ recommendedItem, predictedItem });
      }
      const sortedData = getSortedData(rowData);

      setRowData(sortedData);
    }
  }, [predictionData]);

  const callPredict = async () => {
    setErrorMsgFailedPrediction(null);
    dispatch(storePredictionData(null));
    dispatch(storeForcastWindow(forecastDays));
    setRowData(null);
    setPredictionData(null);
    setIsLoading(true);
    setDisableNextButton(true);
    setprocessedPercentage("1%");
    var task_id = taskId;

    if (!taskId) {
      const calculation = await predictionCalculation(parseInt(forecastDays));
      if (calculation?.data?.task_id) {
        task_id = calculation?.data?.task_id;
        dispatch(storeCATaskId(task_id));
        setTaskId(task_id);
      }
      if (calculation?.data["modeling"]) {
        const d = calculation?.data["modeling"].replaceAll(
          "-Infinity",
          '"-Infinity"'
        );
        const parsedData = JSON.parse(d);
        setPredictionData(parsedData);
      }
    }
    //checkStatus(task_id);
    intervalRef.current = setInterval(function () {
      checkStatus(task_id);
    }, 15000);
  };

  const onPredictClicked = async () => {
    try {
      trackEvent(APPINSIGHTS_STRINGS.PREDICT_CIP_CLICKED, {
        forecastDays: forecastDays,
        plantName: plantName,
        plantLocation: plantLocation
      });
      
      if (
        forecastDays &&
        parseInt(forecastDays) > parseInt(limitWindow.soft_limit) &&
        parseInt(forecastDays) <= parseInt(limitWindow.hard_limit)
      ) {
        setIsOutsideSoftLimit(true);
        return;
      } else if (forecastDays > limitWindow.hard_limit) {
        setIsOutsideRange(true);
        return;
      } else if (!forecastDays) {
        setErrorMsg(t("predictionStrings.forecastError"));
        return;
      }
      await callPredict();
    } catch (err) {}
  };

  const onProceedClicked = async (value) => {
    setIsOutsideSoftLimit(false);
    if (value.action === "CONFIRM") {
      await callPredict();
    } else {
      setIsLoading(false);
    }
    // setIsOutsideSoftLimit(false);
  };

  useEffect(() => {
    const fetchLimit = async () => {
      try {
        const limits = await getPredictLimits();
        if (limits.data) {
          setLimitWindow(limits.data);
          // Check for previous_prediction and set forecast window and prediction data if present
          if (limits.data.previous_prediction) {
            const previous_value = limits.data.previous_prediction;
            if (previous_value.forecast_window) {
              setForecastDays(Math.ceil(previous_value.forecast_window));
            }
            if (previous_value.result) {
              try {
                const parsedResult = JSON.parse(previous_value.result);
                setPredictionData(parsedResult);
              } catch (err) {
                console.log("Error is " + err);
              }
            }
          } else if (!forecastDays) {
            setForecastDays(Math.ceil(limits.data.default_limit));
          }
        }
      } catch (err) {}
    };

    fetchLimit();
  }, []);

  const formattedCurrency = (value) => {
    return `${formattedCurrencyValue(value, exportAllData.others[0].currency)}`;
  };

  const formattedWaterProductionIncrease = (value, percentValue) => {
    const unit = volumeUnit === "m3" ? "m³" : volumeUnit;
    const formattedValue = value ? parseFloat(value).toFixed(2) : "0";
    const formattedPercent = percentValue
      ? parseFloat(percentValue).toFixed(2)
      : "0";
    return `${formattedValue} ${unit} (${formattedPercent}%)`;
  };

  const formattedEnergyCostSavings = (value, percentValue) => {
    const formattedPercent = percentValue?.toFixed(2) || "0";
    const formattedValue = formattedCurrency(value);
    return `${formattedValue} (${formattedPercent} %)`;
  };

  const displayMessage = (optimization_target) => {
    const messages = {
      "Minimize Total Cost": t("predictionStrings.minimizeTotalCost"),
      "Maximize Production Volume": t(
        "predictionStrings.maximizeProductionVolume"
      ),
      "Minimize Energy Cost": t("predictionStrings.minimizeEnergyCost"),
    };
    return (
      t("predictionStrings.optimizationObjective") +
      ": " +
      (messages[optimization_target] || "")
    );
  };

  const getOptimizationMessage = (optimization_target) => {
    const messages = {
      "Minimize Total Cost": t("predictionStrings.overallFinancialBenefits"),
      "Maximize Production Volume": t(
        "predictionStrings.waterProductionIncrease"
      ),
      "Minimize Energy Cost": t("predictionStrings.energyCostSavings"),
    };

    return messages[optimization_target] || "";
  };

  const getOptimizationResult = (optimization_target, data) => {
    const optimizationMap = {
      "Minimize Total Cost": () =>
        formattedCurrency(data.totalFinancialBenefits),
      "Maximize Production Volume": () =>
        formattedWaterProductionIncrease(
          data.increasedProduction,
          data.increasedProductionPercent
        ),
      "Minimize Energy Cost": () =>
        formattedEnergyCostSavings(data.energySaving, data.energySavingPercent),
    };

    return optimizationMap[optimization_target]?.() || null;
  };

  const shouldRenderPrediction = (optimization_target, data) => {
    if (
      optimization_target === "Minimize Total Cost" &&
      data.totalFinancialBenefits > 0
    ) {
      return true;
    }
    if (
      optimization_target === "Maximize Production Volume" &&
      data.increasedProduction > 0
    ) {
      return true;
    }
    if (
      optimization_target === "Minimize Energy Cost" &&
      data.energySaving > 0
    ) {
      return true;
    }
  };
  const shouldRenderError = (optimization_target, data) => {
    if (
      optimization_target === "Minimize Total Cost" &&
      data.totalFinancialBenefits <= 0
    ) {
      return true;
    }
    if (
      optimization_target === "Maximize Production Volume" &&
      data.increasedProduction <= 0
    ) {
      return true;
    }
    if (
      optimization_target === "Minimize Energy Cost" &&
      data.energySaving <= 0
    ) {
      return true;
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      {showOverlayLoader && <OverlayLoader customHeight={"350px"} />}
      <div>
        <div className="descriptionText">
          {t("predictionStrings.predictDescription")}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            marginTop: "20px",
            justifyContent: "space-between",
          }}
        >
          <div className="d-flex flex-end">
            <InputBox
              value={forecastDays}
              labelText={t("predictionStrings.forecastWindow")}
              onChange={onForecastDaysChange}
              isRequired
              errorMsg={errorMsg}
              customClass="width30 dupont-form-label"
              validator={TextFieldValidator.NUMBER_ONLY}
              disabled={isLoading}
              hideClearBtn={isLoading}
            />
            <DupontButton
              onClick={onPredictClicked}
              customClass="margin-left-10"
              disabled={!forecastDays || isLoading}
            >
              {t("predictionStrings.predict")}
            </DupontButton>
            <div className="margin-left-20">
              <b>{displayMessage(optimization_target)}</b>
            </div>
            <div
              style={{
                marginLeft: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <PopoverText
                descriptor={<img src={InfoIconGreen} alt="info icon" />}
                descriptionText={t("predictionStrings.predictDescriptionLine")}
              />
              <PopoverText
                descriptor={<img src={QuestionIcon} alt="question icon" />}
                descriptionText={
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t(
                        "predictionStrings.troubleshootingPrediction"
                      ).replace("<unit>", pressure || "bar/psig"),
                    }}
                  />
                }
              />
            </div>
          </div>
          <div>
            <DupontButton
              onClick={() =>
                exportAllTables(
                  exportAllSheetName,
                  exportAllData,
                  foulingType,
                  t
                )
              }
              customClass="margin-left-10"
              disabled={predictionData === null || isLoading}
            >
              {t("predictionStrings.exportAll")}
            </DupontButton>
          </div>
        </div>
        {limitWindow && (
          <div className="descriptionText marginTop5">
            {t("predictionStrings.recommendedRange").replace(
              "<value>",
              Math.ceil(0.1 * limitWindow.hard_limit)
            )}
            - {Math.ceil(limitWindow.soft_limit)},
            {t("predictionStrings.upperLimit")}-{" "}
            {parseInt(limitWindow.hard_limit)}
          </div>
        )}

        {isLoading ? (
          <PageLoading
            customHeight={150}
            iconHeight={"height--70"}
            message={t("ValueStrings.loaderMessage")}
            percentage={processedPercentage}
          ></PageLoading>
        ) : (
          <div>
            <div style={{ display: "flex", marginTop: 10, marginBottom: 10 }}>
              {rowData && (
                <div style={{ flex: 1 }}>
                  <AgTable
                    rowData={rowData}
                    columnDefs={colDef}
                    domLayout="autoHeight"
                    name={`${t("excelSheetNames.predict")}.csv`}
                  ></AgTable>
                </div>
              )}
            </div>

            {errorMsgFailedPrediction && (
              <div style={{}} className="errorMsg">
                {errorMsgFailedPrediction}
              </div>
            )}

            {predictionData &&
              shouldRenderPrediction(optimization_target, {
                totalFinancialBenefits,
                increasedProduction,
                energySaving,
              }) && (
                <>
                  <div
                    className="bodyMainHeadingText marginTop10"
                    style={{
                      color: "teal",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {" "}
                    {t("predictionStrings.projectedWindow")} - (
                    {setTotalbenefitWindow()})
                    {optimization_target === "Minimize Total Cost" && (
                      <PopoverText
                        descriptor={<img src={InfoIconGreen} alt="info icon" />}
                        descriptionText={t(
                          "predictionStrings.totalFinancialBenefitsDescription"
                        )}
                      />
                    )}
                  </div>
                  <div className="bodyMainHeadingText marginTop10 blackBorder flex-ai-center">
                    {getOptimizationMessage(optimization_target)}
                    {optimization_target === "Minimize Total Cost" && (
                      <PopoverText
                        descriptor={<img src={InfoIconGreen} alt="icon" />}
                        descriptionText={t(
                          "predictionStrings.totalBenefitNote"
                        )}
                      />
                    )}
                    :{" "}
                    {getOptimizationResult(optimization_target, {
                      totalFinancialBenefits,
                      increasedProduction,
                      increasedProductionPercent,
                      energySaving,
                      energySavingPercent,
                    })}
                  </div>

                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {Object.entries(financialBenefits).map(([key, value]) => (
                      <BoxCompontent
                        title={value}
                        value={predictionData[key + "_dollars"]}
                        percentageValue={predictionData[key + "_percent"]}
                        volume={predictionData[key]}
                      ></BoxCompontent>
                    ))}
                  </div>
                </>
              )}

            {predictionData &&
              predictionData.forcast_window < 365 &&
              predictionData.forcast_window > 182 &&
              shouldRenderPrediction(optimization_target, {
                totalFinancialBenefits: annualTotalFinancialBenefits,
                increasedProduction: increasedProductionAnnual,
                energySaving: energySavingAnnual,
              }) && (
                <div>
                  <div
                    className="bodyMainHeadingText marginTop10 "
                    style={{ color: "teal" }}
                  >
                    {" "}
                    {t("predictionStrings.projectedAnnualBenefits")} - (
                    {setAnnualbenefitWindow()} ){" "}
                  </div>
                  <div className="bodyMainHeadingText marginTop10 blackBorder flex-ai-center">
                    {getOptimizationMessage(optimization_target)}
                    {optimization_target === "Minimize Total Cost" && (
                      <PopoverText
                        descriptor={<img src={InfoIconGreen} alt="icon" />}
                        descriptionText={t(
                          "predictionStrings.annualBenefitNote"
                        )}
                      />
                    )}
                    :{" "}
                    {getOptimizationResult(optimization_target, {
                      totalFinancialBenefits: annualTotalFinancialBenefits,
                      increasedProduction: increasedProductionAnnual,
                      increasedProductionPercent:
                        increasedProductionPercentAnnual,
                      energySaving: energySavingAnnual,
                      energySavingPercent: energySavingPercentAnnual,
                    })}
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {Object.entries(annualBenefits).map(([key, value]) => (
                      <BoxCompontent
                        title={value}
                        value={predictionData[key + "_dollars"]}
                        percentageValue={predictionData[key + "_percent"]}
                        volume={predictionData[key]}
                      ></BoxCompontent>
                    ))}
                  </div>
                </div>
              )}

            {predictionData &&
              shouldRenderError(optimization_target, {
                totalFinancialBenefits,
                increasedProduction,
                energySaving,
              }) &&
              shouldRenderError(optimization_target, {
                totalFinancialBenefits: annualTotalFinancialBenefits,
                increasedProduction: increasedProductionAnnual,
                energySaving: energySavingAnnual,
              }) && (
                <div className="errorMsg margin-top-20 blackBorder">
                  {t("predictionStrings.noData")}
                </div>
              )}

            {predictionData &&
              (xtpSavings?.xtp_cost_savings > 0 ||
                xtpSavings?.xtp_water_benefit > 0) && (
                <XTPBenefits
                  xtpSavings={xtpSavings}
                  forecastDays={forecastDays}
                />
              )}

            {(rowData || predictionData) && (
              <div className="XTPDisclaimerText marginTop10 marginBtm10">
                {t("integraTecXTP.disclaimerText")}
              </div>
            )}
          </div>
        )}

        {isOutSideRange && (
          <CriticalDeleteDialog
            type="error"
            title={t("predictionStrings.forecastedDays")}
            description={t("predictionStrings.forecastDescription")
              .replace("<forecastDays>", forecastDays)
              .replace("<HardLimit>", parseInt(limitWindow.hard_limit))
              .replace(
                /<lowerLimit>/g,
                Math.ceil(0.1 * limitWindow.hard_limit)
              )}
            onDialogClose={onBackClicked}
            cancelBtnText={t("ValueStrings.cancel")}
          />
        )}

        {isOutsideSoftLimit && (
          <CriticalDeleteDialog
            type="warning"
            cancelBtnText={t("ValueStrings.cancel")}
            confirmBtnText={t("ValueStrings.proceed")}
            title={t("predictionStrings.proceedConfirmation")}
            description={t("predictionStrings.lowerForecastDescription")
              .replace("<forecastDays>", forecastDays)
              .replace("<HardLimit>", Math.ceil(limitWindow.soft_limit))
              .replace(
                /<lowerLimit>/g,
                Math.ceil(0.1 * limitWindow.hard_limit)
              )}
            onDialogClose={onProceedClicked}
          />
        )}
      </div>
    </div>
  );
};

export default PredictCIP;
